/* Sukhara Collection PLP — interactivity for cards (swatches, variant drawer, quick-add) */
(function() {
  'use strict';

  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function $(sel, root) { return (root || document).querySelector(sel); }

  function fmtMoney(cents) {
    return '₹' + (cents / 100).toLocaleString('en-IN');
  }

  // ============= SWATCHES — swap card image AND rewrite link to ?variant=<id> =============
  function initSwatches(card) {
    var swatches = $$('[data-sk-swatch]', card);
    if (!swatches.length) return;

    // Both layers — primary AND secondary (which appears on hover) need swapping.
    var primaryImg = $('[data-sk-primary]', card) || $('.sk-card__img--primary', card);
    var secondaryImg = $('.sk-card__img--secondary', card);

    var productUrl = card.getAttribute('data-product-url') || '';
    var cardLinks = $$('a[href]', card).filter(function(a) {
      var href = a.getAttribute('href') || '';
      return productUrl && (href === productUrl || href.indexOf(productUrl + '?') === 0 || href.indexOf(productUrl + '/') === 0);
    });

    function setLinksToVariant(variantId) {
      if (!variantId || !productUrl) return;
      var newHref = productUrl + (productUrl.indexOf('?') > -1 ? '&' : '?') + 'variant=' + encodeURIComponent(variantId);
      cardLinks.forEach(function(a) { a.setAttribute('href', newHref); });
    }

    function applySwap(sw) {
      var newSrc = sw.getAttribute('data-image');
      var newSrcset = sw.getAttribute('data-image-srcset');

      if (newSrc) {
        if (primaryImg) {
          primaryImg.setAttribute('src', newSrc);
          if (newSrcset) primaryImg.setAttribute('srcset', newSrcset);
        }
        // Swap secondary too so hover doesn't reveal the wrong color.
        if (secondaryImg) {
          secondaryImg.setAttribute('src', newSrc);
          if (newSrcset) secondaryImg.setAttribute('srcset', newSrcset);
        }
      }

      swatches.forEach(function(s) { s.classList.remove('is-active'); });
      sw.classList.add('is-active');

      var vid = sw.getAttribute('data-variant-id');
      setLinksToVariant(vid);
    }

    swatches.forEach(function(sw) {
      var isSoldOut = sw.classList.contains('sk-swatch--soldout') || sw.hasAttribute('data-sk-swatch-soldout');

      // Block click on sold-out swatches entirely
      var handler = function(e) {
        e.preventDefault();
        e.stopPropagation();
        if (isSoldOut) return;
        applySwap(sw);
      };
      sw.addEventListener('click', handler);

      // Hover preview on desktop — only for in-stock colors
      sw.addEventListener('mouseenter', function() {
        if (isSoldOut) return;
        if (window.matchMedia('(hover: hover)').matches) applySwap(sw);
      });
    });
  }

  // ============= VARIANT DRAWER =============
  function initVariantDrawer(card) {
    var openBtn = $('[data-sk-open-variant-drawer]', card);
    var drawer = $('[data-sk-variant-drawer]', card);
    if (!openBtn || !drawer) return;

    var closeBtn = $('[data-sk-close-variant-drawer]', drawer);
    var form = $('[data-sk-quick-add-form]', drawer);
    var variantInput = $('[data-sk-variant-id-input]', drawer);
    var priceEl = $('[data-sk-drawer-price]', drawer);
    var stockEl = $('[data-sk-drawer-stock]', drawer);
    var submitBtn = $('[data-sk-drawer-submit]', drawer);
    var dataScript = $('[data-sk-variants]', drawer);

    var variants = [];
    try { variants = JSON.parse(dataScript.textContent); } catch (e) { console.error('Variant parse', e); }

    function getSelectedOptions() {
      var fieldsets = $$('[data-option-index]', drawer);
      return fieldsets.map(function(fs) {
        var checked = fs.querySelector('input[type="radio"]:checked');
        return checked ? checked.value : null;
      });
    }

    function findVariant(opts) {
      return variants.find(function(v) {
        return v.options.length === opts.length && v.options.every(function(o, i) { return o === opts[i]; });
      });
    }

    function updateUI() {
      var opts = getSelectedOptions();
      var v = findVariant(opts);
      if (!v) {
        submitBtn.disabled = true;
        submitBtn.textContent = 'Unavailable';
        if (priceEl) priceEl.textContent = '';
        if (stockEl) stockEl.textContent = '';
        return;
      }
      variantInput.value = v.id;
      priceEl.textContent = v.priceFormatted;
      if (!v.available) {
        submitBtn.disabled = true;
        submitBtn.textContent = 'Sold out';
        if (stockEl) stockEl.textContent = '';
      } else {
        submitBtn.disabled = false;
        submitBtn.textContent = 'Add to cart';
        if (stockEl) {
          if (v.inventoryManagement && v.inventoryQty > 0 && v.inventoryQty <= 5) {
            stockEl.textContent = 'Only ' + v.inventoryQty + ' left';
            stockEl.classList.add('is-low');
          } else {
            stockEl.textContent = '';
            stockEl.classList.remove('is-low');
          }
        }
      }
    }

    drawer.querySelectorAll('input[type="radio"][data-option-value]').forEach(function(r) {
      r.addEventListener('change', updateUI);
    });

    function open() {
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      updateUI();
    }
    function close() {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
    }
    openBtn.addEventListener('click', function(e) {
      e.preventDefault();
      open();
    });
    if (closeBtn) closeBtn.addEventListener('click', function(e) { e.preventDefault(); close(); });

    // Close when clicking outside
    document.addEventListener('click', function(e) {
      if (!drawer.classList.contains('is-open')) return;
      if (!drawer.contains(e.target) && e.target !== openBtn) {
        close();
      }
    });

    card._skCloseVariant = close;
  }

  // ============= QUICK ADD — fetch /cart/add.js with sections, then open mini-cart =============
  function getCartSectionsToFetch() {
    var miniCart = document.querySelector('mini-cart');
    if (!miniCart || typeof miniCart.getSectionsToRender !== 'function') {
      return ['mini-cart', 'cart-icon-bubble', 'mobile-cart-icon-bubble'];
    }
    return miniCart.getSectionsToRender().map(function(s) { return s.section; });
  }

  function performAddToCart(form, btn) {
    var formData = new FormData(form);
    var items = [{ id: formData.get('id'), quantity: parseInt(formData.get('quantity') || '1', 10) }];

    var sections = getCartSectionsToFetch();
    var body = {
      items: items,
      sections: sections.join(','),
      sections_url: window.location.pathname
    };

    btn.disabled = true;
    var originalText = btn.querySelector('span') ? btn.querySelector('span').textContent : btn.textContent;
    if (btn.querySelector('span')) btn.querySelector('span').textContent = 'Adding...';
    else btn.textContent = 'Adding...';

    var addUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root)
      ? window.Shopify.routes.root + 'cart/add.js'
      : '/cart/add.js';

    return fetch(addUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
      body: JSON.stringify(body)
    })
      .then(function(r) {
        if (!r.ok) {
          return r.json().then(function(err) { throw new Error(err.description || err.message || 'Add to cart failed'); });
        }
        return r.json();
      })
      .then(function(state) {
        if (btn.querySelector('span')) btn.querySelector('span').textContent = '✓ Added';
        else btn.textContent = '✓ Added';

        var miniCart = document.querySelector('mini-cart');
        if (miniCart && typeof miniCart.renderContents === 'function' && state && state.sections) {
          miniCart.renderContents(state);
        } else {
          var drawer = document.querySelector('cart-drawer');
          if (drawer && typeof drawer.openMenuDrawer === 'function') drawer.openMenuDrawer();
        }

        setTimeout(function() {
          btn.disabled = false;
          if (btn.querySelector('span')) btn.querySelector('span').textContent = originalText;
          else btn.textContent = originalText;

          // close any variant drawer this button is inside
          var card = btn.closest('[data-sk-card]');
          if (card && typeof card._skCloseVariant === 'function') card._skCloseVariant();
        }, 900);
      })
      .catch(function(err) {
        console.error('Quick Add error', err);
        if (btn.querySelector('span')) btn.querySelector('span').textContent = (err && err.message) || 'Try again';
        else btn.textContent = (err && err.message) || 'Try again';
        setTimeout(function() {
          btn.disabled = false;
          if (btn.querySelector('span')) btn.querySelector('span').textContent = originalText;
          else btn.textContent = originalText;
        }, 2200);
      });
  }

  function initQuickAdd(card) {
    var forms = $$('[data-sk-quick-add-form]', card);
    forms.forEach(function(form) {
      form.addEventListener('submit', function(e) {
        e.preventDefault();
        var btn = form.querySelector('button[type="submit"], button[data-sk-quick-add], button[data-sk-drawer-submit]');
        if (!btn) return;
        performAddToCart(form, btn);
      });
    });
  }

  // ============= INIT =============
  function initCard(card) {
    if (card.dataset.skInit === '1') return;
    card.dataset.skInit = '1';
    initSwatches(card);
    initVariantDrawer(card);
    initQuickAdd(card);
  }

  function initAll(root) {
    $$('[data-sk-card]', root || document).forEach(initCard);
  }

  // Initial load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { initAll(); });
  } else {
    initAll();
  }

  // Re-init after Load More appends new cards
  // Watch the grid for added nodes
  var gridObserver = new MutationObserver(function(mutations) {
    mutations.forEach(function(m) {
      m.addedNodes.forEach(function(node) {
        if (node.nodeType !== 1) return;
        if (node.matches && node.matches('[data-sk-card]')) initCard(node);
        if (node.querySelectorAll) initAll(node);
      });
    });
  });

  document.querySelectorAll('[data-sk-grid]').forEach(function(grid) {
    gridObserver.observe(grid, { childList: true });
  });

  // Re-init when Shopify section reloads (theme editor)
  document.addEventListener('shopify:section:load', function(e) { initAll(e.target); });
})();